import { c as _c } from "react/compiler-runtime";
import type { Sponsor } from 'api-graphql-types/server';
import { formatCents } from 'betterplace-utils';
import classNames from 'classnames';
import { ProgressBar } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { useMemo } from 'react';
import styles from './Progress.module.css';
import type { Maybe } from '@/types';
type ProgressProps = {
  donationAmount: number;
  receivedDonationsCount: number;
  sponsor?: Maybe<Sponsor>;
  target?: Maybe<number>;
};
function VerticalLine() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.verticalLine} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function Progress({
  sponsor,
  receivedDonationsCount,
  donationAmount,
  target
}: ProgressProps) {
  const t = useTranslations('nextjs.receiver_pages.fundraising_event');
  const tCore = useTranslations('nextjs.core');
  const locale = useLocale();
  const leftBoxLabel = sponsor?.donatedAmountCaption || tCore('collected');
  const rightBoxLabel = sponsor?.specialAmountCaption ? sponsor.specialAmountCaption : target ? t('our_goal') : tCore('donated');
  const amount = sponsor?.specialAmountInCents || target;
  const rightBoxNr = amount ? formatCents(locale, amount) : receivedDonationsCount;
  const formattedDonationAmount = useMemo(() => formatCents(locale, donationAmount), [locale, donationAmount]);
  const showProgressBar = !!target;
  const centerAmounts = !showProgressBar;
  return <section className={styles.container}>
      <div className={classNames(styles.numbersContainer, {
      [styles.centerAmounts!]: centerAmounts
    })}>
        {/* Left section / Actual */}
        <div className={classNames(styles.donationContainer, {
        [styles.centerAmounts!]: centerAmounts
      })}>
          <div className={styles.number}>{formattedDonationAmount}</div>
          <div className={styles.label}>{leftBoxLabel}</div>
        </div>
        <VerticalLine />
        {/* Right section / Target */}
        <div className={classNames(styles.goalContainer, {
        [styles.centerAmounts!]: centerAmounts
      })}>
          <div className={styles.number}>{rightBoxNr}</div>
          <div className={styles.label}>{rightBoxLabel}</div>
        </div>
      </div>
      {showProgressBar ? <ProgressBar value={donationAmount} max={target} valueText={`${formattedDonationAmount} of ${target}`} invisibleLabelText={`${formattedDonationAmount} / ${target}`} /> : null}
    </section>;
}
export default Progress;